import type { StoreLocation } from '../../../../types/services/auth';

const DEFAULT_VENDING_BIN_COUNT = 24;

const normalizeVendingBinCount = (value: unknown): number => {
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed < 1) {
    return DEFAULT_VENDING_BIN_COUNT;
  }

  return Math.min(parsed, 500);
};

const getPrimaryVendingLocation = (locations: StoreLocation[]): StoreLocation | null => {
  const vendingLocations = locations.filter((location) => (
    String(location.location_type || '').toLowerCase() === 'vending'
    && location.active !== false
  ));

  return vendingLocations.find((location) => Boolean(location.is_default)) || vendingLocations[0] || null;
};

export const resolveVendingLocationConfig = (
  locations: StoreLocation[],
  locationKey: string,
  storeLocationId?: string | null,
): { locationKey: string; locationId: string; binCount: number } => {
  const normalizedLocationKey = String(locationKey || '').trim();
  const normalizedLocationId = String(storeLocationId || '').trim();
  const matchingLocation = (
    normalizedLocationId
      ? locations.find((location) => String(location.id) === normalizedLocationId)
      : null
  ) || (
    normalizedLocationKey
      ? locations.find((location) => String(location.location_key || '').trim() === normalizedLocationKey)
      : null
  );
  const location = matchingLocation || getPrimaryVendingLocation(locations);

  return {
    locationKey: String(location?.location_key || normalizedLocationKey).trim(),
    locationId: String(location?.id || normalizedLocationId).trim(),
    binCount: normalizeVendingBinCount(location?.vending_bin_count),
  };
};
